import React from "react";
import { Navbar } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Image from "react-bootstrap/Image";
import { labels } from "../../../../localization/labels";
import SubmitButton from "../../../core/SubmitButton";
import Breadcrumbs from "../../../core/Breadcrumbs";
import { Affix } from "antd";
import Settings from "../Settings";

const TopBar = props => {
  const user = props.user;

  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      {user != null && (
        <Navbar bg="topBar" className="justify-content-between">
          <div>
            <Breadcrumbs
              ref={props.breadcrumbsRef}
              onClick={props.onBreadcrumbClick}
            />
          </div>
          <ButtonToolbar>
            {["bottom"].map(placement => (
              <OverlayTrigger
                trigger="click"
                key={placement}
                placement={placement}
                opacity="1"
                rootClose
                overlay={
                  <Popover id={`popover-positioned-${placement}`}>
                    <Popover.Title as="h3">
                      <Image
                        src={require("../../../../assets/images/icons8-user-100.png")}
                        roundedCircle
                        className="dropDownImg"
                      />
                      {"  "}
                      {user.username}
                    </Popover.Title>
                    <Popover.Content>
                      <Affix offsetBottom={true}>
                        <div className="d-flex ">
                          <div>
                            <SubmitButton
                              onClick={props.onLogout}
                              text={labels.logout}
                              className="buttonStyle"
                            />
                          </div>
                          <div className="ml-auto">
                            <SubmitButton
                              type="settings"
                              transparent
                              onClick={event => {
                                event.preventDefault();
                                document.body.click();
                                handleShow();
                              }}
                            />
                          </div>
                        </div>
                      </Affix>
                    </Popover.Content>
                  </Popover>
                }
              >
                <div>
                  <Image
                    title={user.username}
                    src={require("../../../../assets/images/icons8-user-100.png")}
                    roundedCircle
                    className="topBarImg"
                  />
                </div>
              </OverlayTrigger>
            ))}
          </ButtonToolbar>
          <Settings
            show={show}
            handleClose={handleClose}
            messageHandler={props.messageHandler}
          />
        </Navbar>
      )}
    </div>
  );
};

export default TopBar;
